export enum IntermediaryVariables {
  IntermediaryName = 'intermediary_business_name',
  IntermediaryEmail = 'intermediary_email',
  IntermediaryPhone = 'intermediary_phone',
  UTMSource = 'intermediary_utm_source',
  UTMMedium = 'intermediary_utm_medium',
  UTMCampaign = 'intermediary_utm_campaign',
  CampaignID = 'intermediary_campaign_id',
  ADGroupID = 'intermediary_ad_group_id',
  Network = 'intermediary_network',
  Device = 'intermediary_device',
  Refer = 'intermediary_refer',
  SourceType = 'intermediary_source_type',
  SourceName = 'intermediary_source_name',
  MainContactFirstName = 'intermediary_main_contact_first_name',
  MainContactLastName = 'intermediary_main_contact_last_name',
  MainContactPosition = 'intermediary_main_contact_position',
  MailingAddress = 'intermediary_mailing_address',
  IntermediaryCity = 'intermediary_city',
  IntermediaryState = 'intermediary_state',
  IntermediaryZipCode = 'intermediary_zip_code',
  WebsiteOrFacebookPage = 'intermediary_website_or_facebook_page',
  Backyard = 'intermediary_backyard',
  GeneralHomeImprovements = 'intermediary_general_home_improvements',
  OtherProjects = 'intermediary_other_projects',
  OtherProjectType = 'intermediary_other_project_type',
  ConfirmIntermediaryEmail = 'confirm_intermediary_email',
  HelpWithLink = 'intermediary_help_with_link',
  JobsPerYear = 'intermediary_average_jobs',
  OwnerFirstName = 'intermediary_owner_first_name',
  OwnerLastName = 'intermediary_owner_last_name',
  SecondaryEmail = 'intermediary_secondary_email',
  TertiaryEmail = 'intermediary_tertiary_email',
  QuaternaryEmail = 'intermediary_quaternary_email',
  CSM = 'intermediary_csm',
  DefaultConsultant = 'intermediary_default_consultant',
  PromoCode = 'intermediary_promo_code',
  PersonalizedLink = 'intermediary_personalized_link',
  IntermediaryStatus = 'intermediary_status',
  AddressVerified = 'intermediary_address_verified',
  PhoneVerified = 'intermediary_phone_verified',
  PrimaryContactVerified = 'intermediary_primary_contact_verified',
  EmailsVerified = 'intermediary_emails_verified',
  GroupId1 = 'intermediary_group_id_1',
  GroupId2 = 'intermediary_group_id_2',
  GroupId3 = 'intermediary_group_id_3',
  IntermediaryCsmSenderName = 'intermediary_csm_sender_name',
  IntermediaryCsmSenderPhone = 'intermediary_csm_sender_phone',
  IntermediaryCsmSenderPosition = 'intermediary_csm_sender_position',
  IntermediaryCsmSenderEmail = 'intermediary_csm_sender_email',
  IntermediaryCsmSenderLink = 'intermediary_csm_sender_link',
  IntermediaryGreetingEmailSent = 'intermediary_greeting_email_sent',
  IntermediaryGreetingTextSent = 'intermediary_greeting_text_sent',
}
